// extracted by mini-css-extract-plugin
export var compactFilters = "_dn-4";
export var detailImage = "_dn-1";
export var dropdownContainer = "_dn-2";
export var imageContainer = "_dn-0";
export var selectedCard = "_dn-3";